import React, { FC } from 'react'

import { PresenterVipDescriptionContainer } from 'components/page/ForeignProfile/Gifts/PresentVip/PresenterVipDescriptionContainer'
import { PresentVipStoreFrontButton } from 'components/page/ForeignProfile/Gifts/PresentVip/PresentVipStoreFrontButton'
import { PresentVipTitleHidden } from 'components/page/ForeignProfile/Gifts/PresentVip/PresentVipTitleHidden'
import { MessageVipForeignView } from 'components/page/ProfileGiftsModal/Message/MessageVipForeignView'
import { MessageVipPublicHiddenView } from 'components/page/ProfileGiftsModal/Message/MessageVipPublicHiddenView'
import { UserCard } from 'components/presentational/card/UserCard'

export const PresentVipDescriptionHideUser: FC<{ days: number }> = ({
  days,
}) => {
  return (
    <PresenterVipDescriptionContainer>
      <UserCard
        title={<PresentVipTitleHidden />}
        text={
          <>
            <MessageVipPublicHiddenView vipDays={days} />
            <br />
            <MessageVipForeignView />
          </>
        }
      >
        <PresentVipStoreFrontButton />
      </UserCard>
    </PresenterVipDescriptionContainer>
  )
}
